import { Camera } from 'domain/camera'
import { CameraHealthStatus } from '../types/camera-health.types'
import { CameraMapStatusInfo, getCameraMapStatus } from 'features/map/utils/camera-map-status'

export interface CameraHealthRow {
  camera: Camera
  health: CameraHealthStatus | undefined
  statusInfo: CameraMapStatusInfo
}

/** Junta a lista completa de câmeras com o snapshot de saúde (StreamHealthMonitor)
 *  por cameraId — ao contrário de `buildMappableCameras`, não descarta quem não
 *  tem coordenadas, porque a tela de saúde não é um mapa. */
export const buildCameraHealthRows = (
  cameras: Camera[],
  health: CameraHealthStatus[]
): CameraHealthRow[] => {
  const healthByCameraId = new Map(health.map((h) => [h.cameraId, h]))

  return cameras.map((camera) => {
    const cameraHealth = healthByCameraId.get(camera.id)
    return {
      camera,
      health: cameraHealth,
      statusInfo: getCameraMapStatus(camera, cameraHealth),
    }
  })
}
